import PropTypes from 'prop-types'
import React, {useState} from 'react'
import "./RocketQuestions.scss"
function RocketQuestions({ questions, onAnswer,currentRepSpeech, selected, setSelected}) {

    return <div className={"questions_container"} >
        {questions && questions.map((q,i) => {
            return <div key={q.caption} className={`question_container ${i === selected && "selected"}`}
                onClick={ ()=> {
                    if (onAnswer) {
                        onAnswer(q.answer || 'mmmh not sure, sorry.')
                        setSelected(i)
                    }
                }
                }
            >
                {q.caption}
            </div>
        })}
    </div>
}

export default RocketQuestions;

RocketQuestions.propTypes = {
  onAnswer: PropTypes.func.isRequired,
  questions: PropTypes.array.isRequired
}
